import { NavLink } from "react-router-dom";
import Faq from "./faq";
import { CONTACT_CONFIG } from '../config/contact';

export default function Use() {
  // Utilisation des variables de configuration centralisées
  const contactInfo = CONTACT_CONFIG;
  return (
    <>
      {/* Header Section */}
      <section className="bg-gradient-to-r from-[#00d4ff] to-[#090979] text-white py-8">
        <div className="h-[25vh]"></div>
        <div className="main-content">
          {/* Main Title */}
          <div className="text-center">
            <h1 className="text-4xl font-bold">Termes et Conditions</h1>
          </div>
          {/* Navigation Breadcrumbs */}
          <div className="text-center mb-4">
            <span className="text-sm">
              <NavLink
                to="/"
                className="transition-all duration-500 hover:text-[#090979]"
              >
                Accueil
              </NavLink>{" "}
              / <span className="text-gray-300">Termes et Conditions</span>
            </span>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="bg-slate-50 text-[#1B1B1B] py-12 min-h-[80vh]">
        <div className="main-content w-[85%] m-auto">
          <div className="space-y-8">
            {/* Section 1 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                1. Acceptation des termes
              </h2>
              <p className="text-base leading-relaxed">
                En accédant à notre site web et en utilisant nos services IPTV,
                vous acceptez ces Termes et Conditions. Si vous n'êtes pas
                d'accord avec ces termes, veuillez ne pas utiliser notre site ou
                nos services.
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">2. Services IPTV</h2>
              <p className="text-base leading-relaxed">
                TVDIAMO propose des abonnements IPTV pour vous permettre de
                profiter d'une grande variété de chaînes et de contenu. Ces
                abonnements sont conçus pour offrir une expérience de
                visualisation de qualité sans avoir besoin de collecter vos
                informations personnelles.
                <br />
                Les codes d'activation et les instructions d'installation vous
                seront fournis immédiatement après votre achat.
              </p>
            </div>

            {/* Section 3 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">3. Confidentialité</h2>
              <p className="text-base leading-relaxed">
                Nous ne collectons aucune donnée personnelle de nos
                utilisateurs. Cela signifie que votre nom, adresse, informations
                de paiement ou tout autre détail identifiable ne sont pas
                collectés ni stockés par TVDIAMO. Votre confidentialité est
                garantie, et nous avons mis en place des mesures pour empêcher
                toute collecte de données par des tiers.
              </p>
              <p className="text-base leading-relaxed pt-2">
                En utilisant nos services, vous pouvez être sûr que vos
                activités restent complètement anonymes et sécurisées.
              </p>
            </div>

            {/* Section 4 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">4. Paiement</h2>
              <p className="text-base leading-relaxed">
                Les paiements sont effectués via des plateformes sécurisées de
                tiers. TVDIAMO ne stocke aucune information de paiement.
                Veuillez suivre les instructions fournies pour finaliser votre
                achat en toute sécurité.
              </p>
            </div>

            {/* Section 5 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                5. Utilisation des services
              </h2>
              <p className="text-base leading-relaxed">
                Les services IPTV fournis par TVDIAMO sont destinés uniquement à
                un usage personnel. Vous ne devez pas partager, redistribuer ou
                revendre les codes d'activation ou le contenu fourni par nos
                services. Toute utilisation abusive peut entraîner la
                résiliation de votre abonnement sans remboursement.
              </p>
            </div>

            {/* Section 6 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">6. Responsabilité</h2>
              <p className="text-base leading-relaxed">
                TVDIAMO s'engage à fournir des services IPTV de haute qualité.
                Cependant, nous ne pouvons pas garantir une disponibilité
                ininterrompue en raison de facteurs externes comme les pannes
                d'Internet ou les problèmes techniques. Nous déclinons toute
                responsabilité pour les interruptions indépendantes de notre
                contrôle.
              </p>
            </div>

            {/* Section 7 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                7. Droits de propriété intellectuelle
              </h2>
              <p className="text-base leading-relaxed">
                Tout le contenu fourni par nos services IPTV, y compris les
                chaînes, films et séries, est protégé par des droits d'auteur et
                des lois de propriété intellectuelle. Vous ne devez pas
                enregistrer, distribuer ou copier ce contenu.
              </p>
            </div>

            {/* Section 8 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                8. Modifications des termes
              </h2>
              <p className="text-base leading-relaxed">
                Nous nous réservons le droit de modifier ces termes à tout
                moment. Toute modification sera publiée sur notre site web. En
                continuant à utiliser nos services après une modification, vous
                acceptez les nouvelles conditions.
              </p>
            </div>

            {/* Section 9 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">9. Contactez-nous</h2>
              <p className="text-base leading-relaxed mb-4">
                Pour toute question sur ces termes et conditions ou pour exercer
                vos droits, vous pouvez nous contacter via :
              </p>
              <ul className="list-disc list-inside space-y-2 text-base">
                <li>Email : {contactInfo.email}</li>
                <li>
                  WhatsApp :{" "}
                  <a
                    href={contactInfo.whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline hover:text-blue-800"
                  >
                    Cliquez ici pour nous contacter
                  </a>
                </li>
              </ul>
            </div>

            {/* Conclusion */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-base leading-relaxed">
                Merci d'avoir choisi {contactInfo.companyName}. Nous sommes fiers de garantir
                votre confidentialité et de vous offrir un service de haute
                qualité sans compromettre votre sécurité ou votre anonymat.
              </p>
            </div>
          </div>
        </div>
        <Faq />
      </section>
    </>
  );
}
